import React, { FunctionComponent, ReactNode } from 'react';

export interface TicketCardGraphicWrapperProps {
    graphic: ReactNode;
}

export const TicketCardGraphicWrapper: FunctionComponent<
    TicketCardGraphicWrapperProps
> = ({ graphic }) => (
    <div className="ticket-card-content__graphic eds-l-sn-mar-right-3 eds-l-mar-right-6">
        {graphic}
    </div>
);

export default TicketCardGraphicWrapper;
